import PageTab from './PageTab';

export default PageTab;
